import { composeStyle } from '@xhs/yam-beer/core/system/compose'
import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'

const hoverState = '&:not([data-disable]):hover, &:not([data-disable])[data-hover]'
const activeStatue = '&:not([data-disable])[data-active="true"]'

export default function initStyle() {
  return [
    registerThemeSpec('cmp.tab', {
      container: {
        '&.tab-position-bottom': {
          display: 'flex',
          flexDirection: 'column-reverse',
          '.tab-headers': {
            mt: 16,
          },
          '.header-line': {
            borderTop: '1px solid #e8e8e8',
          },
          '.header-center': {
            justifyContent: 'center',
          },
        },
        '&.tab-position-left': {
          display: 'flex',
          flexDirection: 'row',
          '.tab-headers': {
            mr: 16,
            flexDirection: 'column',
            width: 'auto',
          },
          '.header-line': {
            borderRight: '1px solid #e8e8e8',
          },
          '.header-center': {
            alignItems: 'center',
          },
        },
        '&.tab-position-right': {
          display: 'flex',
          flexDirection: 'row-reverse',
          '.tab-headers': {
            ml: 'auto',
            flexDirection: 'column',
            width: 'auto',
          },
          '.header-line': {
            borderLeft: '1px solid #e8e8e8',
          },
          '.header-center': {
            alignItems: 'center',
          },
        },
      },
      headers: {
        bg: 'white',
        overflow: 'auto',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        mb: 16,
        '&.header-line': {
          borderBottom: '1px solid #e8e8e8',
        },
        '&.header-center': {
          justifyContent: 'center',
        },
      },
      sized: composeStyle.switch('size')
        .case('s', {
          py: 12,
          px: 6,
          fontSize: 14,
        })
        .case('l', {
          py: 20,
          px: 16,
          fontSize: 16,
        })
        .case('m', {
          py: 16,
          px: 8,
          fontSize: 14,
        }),
      item: {
        whiteSpace: 'nowrap',
        textAlign: 'center',
        position: 'relative',
        fontWeight: 'normal',
        cursor: 'pointer',
        [hoverState]: composeStyle.var('modifier', {
          color: '_VAR_',
          fill: '_VAR_',
        }),
        [activeStatue]: {
          fontWeight: 'medium',
          color: composeStyle.var('modifier', '_VAR_'),
          fill: composeStyle.var('modifier', '_VAR_'),
          '&:after': composeStyle.var('modifier', {
            position: 'absolute',
            content: '\'\'',
            borderRadius: 1.5,
            bg: '_VAR_',
            left: 0,
            bottom: 0,
            width: '100%',
            height: 3,
            '.tab-position-bottom &': {
              left: 0,
              top: 0,
              bottom: 'unset',
              width: '100%',
              height: 3,
            },
            '.tab-position-left &': {
              right: 0,
              left: 'unset',
              top: 0,
              height: '100%',
              width: 3,
            },
            '.tab-position-right &': {
              left: 0,
              top: 0,
              bottom: 'unset',
              height: '100%',
              width: 3,
            },
          }),
        },
        '&[data-disable]': {
          color: '#ccc',
          fill: '#ccc',
          cursor: 'not-allowed',
        },
      },
      badge: {
        minWidth: 42,
      },
    }),
  ]
}
